import {config} from './hapi.config';

export default defineAppConfig({
	host: config[config.default].host,
	lang: config[config.default].lang,
	multiHost: [
		{
			alias: 'tvornicazdravehrane',
			host: 'https://www.tvornicazdravehrane.com',
			lang: 'hr',
			langCountry: 'hr',
		},
		{
			alias: 'healthyfoodfactory',
			host: 'https://www.healthyfoodfactory.eu',
			lang: 'en',
			langCountry: 'en',
		},
		{
			alias: 'tovarnazdravehrane',
			host: 'https://www.tovarnazdravehrane.si',
			lang: 'si',
			langCountry: 'si',
		},
		{
			alias: 'bio-fabrik.de',
			host: 'https://www.bio-fabrik.de',
			lang: 'de',
			langCountry: 'de',
		},
		{
			alias: 'bio-fabrik.at',
			host: 'https://www.bio-fabrik.at',
			lang: 'de',
			langCountry: 'at',
		},
	],
	baseCompatibility: '153',
	cache: {
		enabled: config[config.default].apiCache,
	},
	meta: [{name: 'robots', content: 'max-image-preview:large', rule: {controller: 'publish', action: 'detail'}}],
	publish: {
		postsResponseFields: ['id', 'url_without_domain', 'title', 'category_title', 'headline', 'main_image_thumbs', 'main_image_title', 'main_image_description', 'images', 'short_description', 'feedback_comment_widget', 'feedback_rate_widget', 'category_url_without_domain', 'attributes_summary'],
	},
	webshop: {
		steps: ['customer', 'payment', 'reviewOrder'],
	},
	catalog: {
		quickOrder: true,
		productsResponseFields: [
			'id',
			'code',
			'is_available',
			'priority_details',
			'category_code',
			'category_hierarchy_parents',
			'category_title',
			'discount_percent',
			'discount_percent_custom',
			'payment_prices',
			'price_custom',
			'basic_price',
			'basic_price_custom',
			'price_b2b_custom',
			'basic_price_b2b_custom',
			'loyalty_price',
			'rate',
			'price_rate_custom',
			'url_without_domain',
			'main_image_thumbs',
			'main_image_title',
			'main_image_description',
			'title',
			'is_available',
			'attributes_special',
			'attributes',
			'extra_price_lowest',
			'manufacturer_code',
			'manufacturer_url_without_domain',
			'manufacturer_title',
			'manufacturer_main_image_upload_path',
			'shopping_cart_code',
			'status',
			'feedback_comment_widget',
			'feedback_rate_widget',
			'type',
			'available_qty',
			'package_qty',
			'qty',
			'warehouses',
			'images',
			'element_video',
			'seo_h1',
			'category_url_without_domain',
			'limited_qty',
			'category_position_h',
			'anchor_price',
			'anchor_price_date',
			'anchor_price_visible',
			'unitd_qty',
			'unitd_unit',
		],
		hooks: {
			mapProducts: data => {
				// Keep only warehouses with available_qty > 1, and keep only available_qty property
				if (data.warehouses?.length) {
					const availableWarehouses = data.warehouses.filter((w: any) => Number(w.available_qty) > 0);
					data.warehouses = availableWarehouses.map((w: any) => ({available_qty: w.available_qty}));
				}
				// Keep only id, title, and image_upload_path in attributes_special
				if (data.attributes_special?.length) {
					data.attributes_special = data.attributes_special.map(attr => ({
						id: attr.id,
						title: attr.title,
						image_upload_path: attr.image_upload_path,
					}));
				}
				return data;
			},
		},
		urls: {
			de: {
				items: 'produkte',
				item: 'product',
			},
			at: {
				items: 'produkte',
				item: 'product',
			},
		},
	},
	layouts: [
		{
			template: 'CmsAbout',
			layout: 'about',
		},
	],
	structuredData: {
		basic: {
			name: 'tvornicazdravehrane.com',
			organizationName: 'Galleria Internazionale d.o.o.',
			logo: 'https://www.tvornicazdravehrane.com/images/logo-big.png',
			phone: '+38515573568',
			email: 'info@tvornicazdravehrane.com',
			socialNetworkUrls: '"https://www.facebook.com/tvornicazdravehrane/", "https://www.instagram.com/tvornica_zdrave_hrane/"',
			returnDays: 14,
			shippingCountries: ['SI', 'BG', 'RO', 'DK', 'IT', 'IE', 'VA', 'SK', 'SE', 'PT', 'PL', 'NL', 'LV', 'LU', 'LT', 'HU', 'GR', 'FR', 'FI', 'ES', 'EE', 'DE', 'CZ', 'BE', 'AT', 'HR'],
		},
		hooks: {
			recipeCookTime: data => {
				let cookTime = data.attributes_summary?.vrijeme_pripreme?.content || 0;
				if (!cookTime) return 0;

				let totalMinutes = 0;

				// Extract minutes (e.g., "45min", "30 min")
				const minutesMatch = cookTime.match(/(\d+)\s*min/i);
				if (minutesMatch) {
					totalMinutes += parseInt(minutesMatch[1], 10);
				}

				// Extract hours (e.g., "1h", "1 h")
				const hoursMatch = cookTime.match(/(\d+)\s*h(?!o)/i);
				if (hoursMatch) {
					totalMinutes += parseInt(hoursMatch[1], 10) * 60;
				}

				return totalMinutes;
			},
			recipeIngredient: data => {
				return data.element_ingredients || '';
			},
			recipeCategory: data => {
				const category = data.attributes?.find(attr => attr.attribute_code === 'vrsta_jela') || null;
				return category ? category.title : '';
			},
		},
	},
	facebook: {
		pixel: {
			env: ['production', 'development'],
			apiKey: '759023024186954',
			target: 'head',
			gdpr: false,
		},
		conversionApi: {
			env: ['production', 'development'],
			debug: false,
			events: ['addPaymentInfo', 'addToCart', 'initiateCheckout', 'pageView', 'viewContent', 'purchase'],
			gdpr: false,
		},
	},
	google: {
		gtm: {
			env: ['production', 'development'],
			gdpr: false,
		},
		tracking: {
			gdpr: false,
			debug: false,
			events: ['viewItem', 'selectItem', 'viewItemList', 'addToWishlist', 'removeProduct', 'addProduct', 'viewCart', 'beginCheckout', 'addShippingInfo', 'addPaymentInfo', 'purchase', 'refund', 'viewPromotion', 'selectPromotion'],
			hooks: {
				mapProduct(product, gtmData) {
					return {
						...gtmData,
						item_discount_percentage: product.discount_percent_custom || 0,
						item_reviews_rating: product.feedback_rate_widget?.rates ? Math.round(product.feedback_rate_widget.rates) : 0,
						item_reviews_no: product.feedback_rate_widget?.rates_votes ? Number(product.feedback_rate_widget.rates_votes) : 0,
					};
				},
				afterPush(data) {
					let pushData = {};
					if (data.event == 'view_item_list' && data?.ecommerce?.items?.length) {
						pushData = {
							ecommerce: {
								impressions: data.ecommerce.items.map(item => {
									return {
										action: item.item_list_name || '',
										brand: item.item_brand || '',
										category: item.item_category || '',
										id: item.item_id || '',
										list: item.item_list_name || '',
										name: item.item_name || '',
										position: item.index + 1 || 1,
										price: item.price || 0,
									};
								}),
							},
							event: 'impressions',
						};
						//console.log('impressions', pushData);
					}

					if (data.event == 'view_item' && data?.ecommerce?.items?.length) {
						pushData = {
							ecommerce: {
								detail: {
									actionField: {
										list: 'Kategorija ' + data.ecommerce.items[0].item_category || '',
									},
									products: [
										{
											brand: data.ecommerce.items[0].item_brand || '',
											category: data.ecommerce.items[0].item_category || '',
											id: data.ecommerce.items[0].item_id || '',
											name: data.ecommerce.items[0].item_name || '',
											position: 1,
											price: data.ecommerce.items[0].price || 0,
										},
									],
								},
							},
							event: 'productView',
						};
						//console.log('impressions productView', pushData);
					}

					if (data.event == 'add_to_cart' && data?.ecommerce?.items?.length) {
						pushData = {
							ecommerce: {
								add: {
									products: data.ecommerce.items.map(item => {
										return {
											brand: item.item_brand || '',
											category: item.item_category || '',
											id: item.item_id || '',
											name: item.item_name || '',
											price: item.price || 0,
											quantity: item.quantity || 1,
											variant: item.variant || '',
										};
									}),
								},
								currencyCode: data.ecommerce.currency || 'EUR',
							},
							event: 'AddToCart',
						};
						//console.log('impressions AddToCart', pushData);
					}

					if (data.event == 'remove_from_cart' && data?.ecommerce?.items?.length) {
						pushData = {
							ecommerce: {
								remove: {
									products: data.ecommerce.items.map(item => {
										return {
											brand: item.item_brand || '',
											category: item.item_category || '',
											id: item.item_id || '',
											name: item.item_name || '',
											price: item.price || 0,
											quantity: item.quantity || 1,
										};
									}),
								},
								currencyCode: data.ecommerce.currency || 'EUR',
							},
							event: 'removeFromCart',
						};
						//console.log('impressions removeFromCart', pushData);
					}

					if (data.event == 'view_promotion' && data?.ecommerce) {
						pushData = {
							ecommerce: {
								promoView: {
									promotions: {
										creative: data.ecommerce.creative_name || '',
										id: data.ecommerce.promotion_id || '',
										name: data.ecommerce.promotion_name || '',
										position: data.ecommerce.promotion_position || '',
									},
								},
							},
							event: 'impressionsPromo',
						};
						//console.log('impressionsPromo ' + data.event, pushData);
					}

					window.dataLayer.push(pushData);
				},
			},
			viewCart: {
				hooks: {
					mapData(data) {
						const res = data;
						delete res.ecommerce.value;
						delete res.ecommerce.currency;
						return res;
					},
				},
			},
			addShippingInfo: {
				hooks: {
					mapData(data) {
						const res = data;
						delete res.ecommerce.value;
						delete res.ecommerce.currency;
						delete res.ecommerce.coupon;
						return res;
					},
				},
			},
			addPaymentInfo: {
				hooks: {
					mapData(data) {
						const res = data;
						delete res.ecommerce.value;
						delete res.ecommerce.currency;
						delete res.ecommerce.coupon;
						return res;
					},
				},
			},
		},
		remarketing: {
			env: ['production', 'development'],
			debug: false,
			swapItemIds: true,
			conversionId: '958641031',
			gtm: false,
			events: ['home', 'category', 'offerdetail', 'searchresults', 'conversionintent', 'conversion'],
			category: {
				name: 'other',
				data: ['pagetype'],
			},
			offerdetail: {
				data: ['pagetype', 'id'],
			},
			searchresults: {
				data: ['pagetype'],
			},
			conversionintent: {
				data: ['pagetype', 'id'],
			},
			conversion: {
				data: ['pagetype', 'id'],
			},
			gdpr: false,
		},
	},
	recommendApi: {
		apiToken: '6c375235-826e-47f3-bfe6-0a8b9439a442',
	},
});
